import { createSelector } from '@ngrx/store';

export const getStreetGeoJsonState = createSelector(
    (state: any) => state.map,
    (state: any) => state.get('streetGeoJson')
);

 